import { Routes } from '@angular/router';
import { ListVehicleComponent } from './pages/vehicles/list-vehicle/list-vehicle';
import { VehicleFormComponent } from './pages/vehicles/vehicle-form/vehicle-form';
import { ListUserComponent } from './pages/users/list-user/list-user';
import { UserFormComponent } from './pages/users/user-form/user-form';
import { ListRideComponent } from './pages/rides/list-ride/list-ride';
import { RideFormComponent } from './pages/rides/ride-form/ride-form';
import { ListCustomerComponent } from './pages/customers/list-customer/list-customer';
import { CustomerFormComponent } from './pages/customers/customer-form/customer-form';

export const routes: Routes = [
  { path: '', redirectTo: '/vehicles', pathMatch: 'full' },
  { path: 'vehicles', component: ListVehicleComponent },
  { path: 'vehicles/create', component: VehicleFormComponent },
  { path: 'vehicles/edit/:id', component: VehicleFormComponent },
  { path: 'users', component: ListUserComponent },
  { path: 'users/create', component: UserFormComponent },
  { path: 'users/edit/:id', component: UserFormComponent },
  { path: 'customers', component: ListCustomerComponent },
  { path: 'customers/create', component: CustomerFormComponent },
  { path: 'customers/edit/:id', component: CustomerFormComponent },
  { path: 'rides', component: ListRideComponent },
  { path: 'rides/create', component: RideFormComponent },
  { path: 'rides/edit/:id', component: RideFormComponent },
];
